import { Breadcrumbs, Link } from "@mui/material";
import { useLocation } from "react-router-dom";

const BreadcrumbInvoice = ({ isWarehouse }) => {
  const { pathname } = useLocation();

  return (
    <Breadcrumbs sx={{ color: "#1761FD", marginBottom: 2, fontSize: 12 }}>
      <Link
        href="/profile"
        underline="hover"
        color="#1761FD"
        sx={{ color: "#1761FD" }}
      >
        Homepage
      </Link>
      <Link
        color="#1761FD"
        underline="none"
        href={`${isWarehouse ? "/central-warehouse" : ""}/invoice/invoice`}
        sx={{ color: "#1761FD" }}
      >
        Invoice List
      </Link>
      {pathname.includes("/invoice/invoice/create-invoice") ? (
        <Link
          underline="none"
          color="#1761FD"
          href={`${
            isWarehouse ? "/central-warehouse" : ""
          }/invoice/invoice/create-invoice`}
          sx={{ color: "#1761FD" }}
        >
          Tambah Faktur
        </Link>
      ) : null}
      {pathname.includes("/invoice/invoice/detail-invoice") ? (
        <Link underline="none" color="#1761FD" sx={{ color: "#1761FD" }}>
          Detail Faktur
        </Link>
      ) : null}
    </Breadcrumbs>
  );
};

export default BreadcrumbInvoice;
